module.exports = __webpack_public_path__ + "static/fb-622d26f97c4c994f63519c0bede0ee80.png";